// File excluded from token migration due to custom illustration
// https://atlassian.slack.com/archives/CFJ9DU39U/p1709665443238399
import React from 'react';
import { styled } from '@compiled/react';

import Image from '@atlaskit/image';
import { token } from '@atlaskit/tokens';

import DarkIllustration from '../assets/LandInEditorIllustrationDark.svg';
import LightIllustration from '../assets/LandInEditorIllustrationLight.svg';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const IllustrationContainer = styled.div({
	width: '330px',
	height: '150px',
	marginTop: token('space.300', '24px'),
	backgroundColor: token('elevation.surface', '#FFFFFF'),
	borderRadius: '4px 4px 0 0',
	borderBottom: `1px solid ${token('color.background.accent.gray.subtler', '#DCDFE4')}`,
	'@media screen and (max-width: 375px)': {
		marginTop: token('space.600', '48px'),
	},
	'@media screen and (max-width: 1024px)': {
		marginTop: token('space.300', '24px'),
	},
});

// Note: this is used for Land In Editor Banner
export const TemplateBannerIllustration = () => {
	return (
		<IllustrationContainer>
			<Image
				src={LightIllustration}
				srcDark={DarkIllustration}
				alt=""
				testId="template-banner-illustration"
			/>
		</IllustrationContainer>
	);
};
